import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {AuthPage} from '../modules/auth'
import {LandingPage} from '../pages/public/landing/LandingPage'
import {PartnersPage} from '../pages/public/landing/pages/Partners/PartnersPage'
import {ValuesPage} from '../pages/public/landing/pages/Values/ValuesPage'
import {LandingTermsPage} from '../pages/public/landing/components/LandingTermsPage'
import {LandingPrivacyPage} from '../pages/public/landing/components/LandingPrivacyPage'
import { HelpCenterList } from '../pages/helpCenter/HelpCenterList'
import { HelpCenterDetails } from '../pages/helpCenter/HelpCenterDetails'

export function PublicRoutes() {
  return (
    <Switch>
      <Route path='/help-center' component={HelpCenterList} exact/>
      <Route path='/help-center/:id' component={HelpCenterDetails} exact/>
      <Redirect from='/activate-account/:token/:user' to='/auth/activate-account/:token/:user' />
      <Redirect from='/reset-password/:user/:token' to='/auth/reset-password/:user/:token' />
      <Route path='/auth' component={AuthPage} />
      <Route path='/' exact component={LandingPage} />
      <Route path='/partners' component={PartnersPage} />
      <Route path='/values' component={ValuesPage} />
      <Route path='/terms-conditions' component={LandingTermsPage} />
      <Route path='/privacy-policy' component={LandingPrivacyPage} />
      <Redirect to='/' />
    </Switch>
  )
}
